import axios from "axios";
import { BaseEvent } from "../events/base.event";
import App from "../../App";
import Login from "../../components/login/login";
import { HTTP_CODES } from "../constants/httpCodes.constants";

const httpClient = axios.create();
// DEFAULT TIMEOUT OF 2mins
httpClient.defaults.timeout = 6000 * 120;

class BaseService {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }

  getErrorMessage(error) {
    if (typeof error === "undefined") return "NULL";

    if (typeof error.response === "undefined") return "NULL";

    if (typeof error.response.data === "undefined") return "NULL";

    if (typeof error.response.data.message === "undefined")
      return error.response.data;

    return error.response.data.message;
  }

  handleError(error) {
    if (typeof error.response === "undefined") {
      BaseEvent.hideLoader();
      return;
    }

    if (error.response.status == HTTP_CODES.UN_AUTHORIZED) {
      BaseEvent.hideLoader();
      App.showError("session expired");
      App.navigateToLogin();
    }

    if (error.response.status == HTTP_CODES.BAD_REQUEST) {
      BaseEvent.hideLoader();
      if (this.getErrorMessage(error) !== "NULL") {
        return App.showError(this.getErrorMessage(error));
      } else return;
    }

    if (error.response.status == HTTP_CODES.NOT_FOUND) {
      BaseEvent.hideLoader();
      if (this.getErrorMessage(error) !== "NULL") {
        return App.showError(this.getErrorMessage(error));
      } else return;
    }

    if (error.response.status == HTTP_CODES.NOT_ACCEPTABLE) {
      BaseEvent.hideLoader();
    }

    if (error.response.status == HTTP_CODES.INTERNAL_SERVER_ERROR) {
      BaseEvent.hideLoader();
    }
  }

  getURL(data) {
    if (typeof data === "undefined") return "";
    if (typeof data !== "object") throw "data must be object";
    let parameters = Object.getOwnPropertyNames(data);
    let url = "?";
    for (
      let parameterIndex = 0;
      parameterIndex < parameters.length;
      parameterIndex++
    ) {
      let parameter = parameters[parameterIndex];
      let value = data[parameter];
      url += parameter + "=" + value + "&";
    }
    url = url.substring(0, url.length - 1);
    return url;
  }

  makeGetRequest(endPoint, data) {
    return new Promise(async (resolve, reject) => {
      try {
        let url = this.baseUrl + endPoint;
        url += this.getURL(data);
        BaseEvent.showLoader();

        let res = await httpClient.get(url, { headers: this.getHeaders() });
        BaseEvent.hideLoader();
        return resolve(res.data);
      } catch (error) {
        this.handleError(error);
        reject(error);
      }
    });
  }

  getHeaders() {
    return {
      access_token: localStorage.getItem("usertoken"),
    };
  }

  makeGetRequestGeneric(url, headers) {
    return new Promise(async (resolve, reject) => {
      try {
        let headersUsed =
          typeof headers === "undefined" ? this.getHeaders() : headers;
        BaseEvent.showLoader();

        let res = await httpClient.get(url, { headers: headersUsed });
        BaseEvent.hideLoader();
        //App.hideProgress();
        return resolve(res.data);
      } catch (error) {
        this.handleError(error);
        reject(error);
      }
    });
  }

  makeGetRequestGenericWithoutLoader(url, headers) {
    return new Promise(async (resolve, reject) => {
      try {
        let headersUsed =
          typeof headers === "undefined" ? this.getHeaders() : headers;

        let res = await httpClient.get(url, { headers: headersUsed });
        //App.hideProgress();
        return resolve(res.data);
      } catch (error) {
        this.handleError(error);
        reject(error);
      }
    });
  }

  makePostRequestGeneric(url, data, headers) {
    return new Promise(async (resolve, reject) => {
      try {
        let headersUsed =
          typeof headers === "undefined" ? this.getHeaders() : headers;
        BaseEvent.showLoader();
        //App.showProgress();
        let res = await axios.post(url, data, { headers: headersUsed });
        BaseEvent.hideLoader();
        //App.hideProgress();
        return resolve(res.data);
      } catch (error) {
        this.handleError(error);
        //reject(error);
      }
    });
  }

  makePostRequestGenericWithoutLoader(url, data, headers) {
    return new Promise(async (resolve, reject) => {
      try {
        let headersUsed =
          typeof headers === "undefined" ? this.getHeaders() : headers;
        //App.showProgress();
        let res = await axios.post(url, data, { headers: headersUsed });
        //App.hideProgress();
        return resolve(res.data);
      } catch (error) {
        this.handleError(error);
        reject(error);
      }
    });
  }

  makePostRequest(endPoint, data) {
    console.log(data);
    return new Promise(async (resolve, reject) => {
      try {
        let url = this.baseUrl + endPoint;

        BaseEvent.showLoader();
        let res = await httpClient.post(url, data, {
          headers: this.getHeaders(),
        });
        BaseEvent.hideLoader();
        return resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  }

  uploadFile(endPoint, data, fileParameterName, file) {
    return new Promise(async (resolve, reject) => {
      try {
        var formData = new FormData();
        let parameters = Object.getOwnPropertyNames(data);

        for (
          let parameterIndex = 0;
          parameterIndex < parameters.length;
          parameterIndex++
        ) {
          let parameter = parameters[parameterIndex];
          let value = data[parameter];

          formData.set(parameter, value);
        }

        formData.append(fileParameterName, file);
        let url = this.baseUrl + endPoint;

        BaseEvent.showLoader("Uploading ...");
        axios
          .post(url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              access_token: localStorage.getItem("usertoken"),
            },
          })
          .then((res) => {
            setTimeout(() => {
              BaseEvent.hideLoader();
            }, 200);
            return resolve(true);
          });
      } catch (error) {
        console.log("File upload failed");
        if (typeof error.response === "undefined") return;
        BaseEvent.hideLoader();
        if (error.response) {
          // BaseEvent.showError(error.response.data.error);
        } else {
          // BaseEvent.showError("Oops! Something went wrong. Please try again.");
        }
      }
    });
  }
  uploadMultipleFiles(endPoint, data, fileParameterName, files) {
    return new Promise(async (resolve, reject) => {
      try {
        var formData = new FormData();
        let parameters = Object.getOwnPropertyNames(data);

        for (
          let parameterIndex = 0;
          parameterIndex < parameters.length;
          parameterIndex++
        ) {
          let parameter = parameters[parameterIndex];
          let value = data[parameter];

          formData.set(parameter, value);
        }
        Object.keys(files).forEach((file) => {
          formData.append(fileParameterName, files[file]);
        });
        let url = this.baseUrl + endPoint;

        BaseEvent.showLoader("Uploading ...");
        axios
          .post(url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              access_token: localStorage.getItem("usertoken"),
            },
          })
          .then((res) => {
            setTimeout(() => {
              BaseEvent.hideLoader();
            }, 200);
            return resolve(true);
          });
      } catch (error) {
        console.log("File upload failed");
        if (typeof error.response === "undefined") return;
        BaseEvent.hideLoader();
        if (error.response) {
          // BaseEvent.showError(error.response.data.error);
        } else {
          // BaseEvent.showError("Oops! Something went wrong. Please try again.");
        }
      }
    });
  }
}

export default BaseService;
